import { createSlice } from "@reduxjs/toolkit"
import {
  getContractBatchesList,
  getMyContract,
  getNominatedCandidatesForContracts,
  getSignedAndUnSignedCandidates,
  signMyContract,
} from "store/actions/contractsAction"

const payloadInitialState = {
  limit: 50,
  page_number: 1,
  filters: {
    keyword: "",
    is_saudi: null,
    job_title_ids: [],
  },
}

const batchesPayloadInitialState = {
  limit: 50,
  page_number: 1,
  filters: {
    keyword: "",
    date_range: [],
  },
}

const signedAndUnSignedInitialPayload = {
  limit: 50,
  page_number: 1,
  filters: {
    keyword: "",
    job_title_ids: [],
    type: null, // 0,1,2,3 0: pending, 1:sent, 2:signed, 3:rejected
    is_saudi: null,
    date_range: [],
  },
}

const initialState = {
  loading: false,
  isLoading: false,
  isGettingDetails: false,
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  nominatedCandidates: [],
  candidates: [],
  batches: [],
  myContract: null,
  payload: payloadInitialState,
  signedAndUnSignedPayload: signedAndUnSignedInitialPayload,
  batchesPayload: batchesPayloadInitialState,
  activeTab: "exports",
  isShowFilter: false,
}

const contractSlice = createSlice({
  name: "Contract",
  initialState,
  reducers: {
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },
    setBatchesPayload: (state, action) => {
      state.batchesPayload = { ...state.batchesPayload, ...action.payload }
    },
    setSignedAndUnSignedPayload: (state, action) => {
      state.signedAndUnSignedPayload = {
        ...state.signedAndUnSignedPayload,
        ...action.payload,
      }
    },
    resetPayload: state => {
      state.payload = payloadInitialState
      state.batchesPayload = batchesPayloadInitialState
      state.signedAndUnSignedPayload = signedAndUnSignedInitialPayload
    },
    toggleFilterVisibility: state => {
      state.isShowFilter = !state.isShowFilter
    },
    toggleActiveTab: (state, action) => {
      state.activeTab = action.payload
      state.payload = payloadInitialState
      state.batchesPayload = batchesPayloadInitialState
      state.signedAndUnSignedPayload = signedAndUnSignedInitialPayload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(signMyContract.pending, state => {
        state.loading = true
      })
      .addCase(signMyContract.fulfilled, (state, action) => {
        state.loading = false
      })
      .addCase(signMyContract.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getNominatedCandidatesForContracts.pending, state => {
        state.loading = true
      })
      .addCase(
        getNominatedCandidatesForContracts.fulfilled,
        (state, action) => {
          const { success, data } = action.payload || {}
          if (success) {
            const { extra } = data
            state.loading = false
            state.nominatedCandidates = data.data
            state.totalPages = extra.total_pages
            state.totalCount = extra.total_records
            state.currentPage = extra.current_page
          }
        }
      )
      .addCase(getNominatedCandidatesForContracts.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getSignedAndUnSignedCandidates.pending, state => {
        state.loading = true
      })
      .addCase(getSignedAndUnSignedCandidates.fulfilled, (state, action) => {
        const { success, data, total_pages, total_records, current_page } =
          action.payload || {}

        if (success) {
          state.loading = false
          state.jobsCards = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
          state.candidates = data
        }
      })
      .addCase(getSignedAndUnSignedCandidates.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getContractBatchesList.pending, state => {
        state.loading = true
      })
      .addCase(getContractBatchesList.fulfilled, (state, action) => {
        const { success, data, total_pages, total_records, current_page } =
          action.payload || {}
        if (success) {
          state.loading = false
          state.batches = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getContractBatchesList.rejected, (state, action) => {
        state.loading = false
      })
    builder
      .addCase(getMyContract.pending, state => {
        state.loading = true
      })
      .addCase(getMyContract.fulfilled, (state, action) => {
        const { success, data } = action.payload || {}
        if (success) {
          state.loading = false
          state.myContract = data
        }
      })
      .addCase(getMyContract.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export const {
  setPayload,
  resetPayload,
  toggleFilterVisibility,
  toggleActiveTab,
  setBatchesPayload,
  setSignedAndUnSignedPayload,
} = contractSlice.actions
export default contractSlice.reducer
